import { render, staticRenderFns } from "./MessageContent.vue?vue&type=template&id=62db3a40&scoped=true"
import script from "./MessageContent.vue?vue&type=script&lang=js"
export * from "./MessageContent.vue?vue&type=script&lang=js"
import style0 from "./MessageContent.vue?vue&type=style&index=0&id=62db3a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db3a40",
  null
  
)

export default component.exports